module.exports = __webpack_public_path__ + "static/img/diagnostics_system_info.a771861c.svg";